import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getModule } from './module';

export const ReduxInitLoadable: React.FC<{}> = () => (
  <DynamicModuleLoader modules={[getModule()]} />
);
ReduxInitLoadable.displayName = 'TierCreatorReduxLoadable';

export default ReduxInitLoadable;
